import { render, staticRenderFns } from "./articulos-detalles.vue?vue&type=template&id=3c6de0fc&scoped=true&"
import script from "./articulos-detalles.vue?vue&type=script&lang=ts&"
export * from "./articulos-detalles.vue?vue&type=script&lang=ts&"
import style0 from "./articulos-detalles.vue?vue&type=style&index=0&id=3c6de0fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6de0fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCol,VIcon,VRow,VSpacer,VTabItem,VTabsItems,VTooltip})
